import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoaderService } from './loader.service';

export const localLoaderUrls = ['/v1/provider/authentication/login'];

export const loaderInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const loaderService = inject(LoaderService);

  const isLocalLoader = localLoaderUrls.some(url => req.url.includes(url));

  if (!isLocalLoader) loaderService.show();
  else loaderService.showLocal();

  return next(req).pipe(
    catchError(error => {
      if (!isLocalLoader) loaderService.hide();
      else loaderService.hideLocal();
      throw error;
    }),
    finalize(() => {
      if (!isLocalLoader) loaderService.hide();
      else loaderService.hideLocal();
    }),
  );
};
